import React, { useEffect, useState } from "react";
import { ListPage, TableSkeleton } from "@redipos/ui";
import { plataformaApi, type AdminAuditLogRow } from "../api.js";

function formatDateTime(value: string) {
  return new Date(value).toLocaleString("es-PY", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Quién hizo qué dentro del ERP — impersonar, reset de demo, cambios de
 * plan/estado, cambios de config de correo. Ver
 * docs/analisis/consola-admin-rediseno.md §6 (AdminAuditLog).
 */
export default function AuditLogPage() {
  const [rows, setRows] = useState<AdminAuditLogRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    plataformaApi
      .auditLog()
      .then(setRows)
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ListPage title="Auditoría" subtitle="Acciones sensibles ejecutadas dentro del ERP.">
      {loading ? (
        <TableSkeleton rows={6} cols={4} />
      ) : (
        <div className="rounded-input border border-border overflow-hidden">
          <div className="table-x-scroll max-w-full">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-fg-subtle text-xs uppercase bg-surface-elevated">
                  <th className="px-3 py-2 font-medium">Fecha</th>
                  <th className="px-3 py-2 font-medium">Quién</th>
                  <th className="px-3 py-2 font-medium">Acción</th>
                  <th className="px-3 py-2 font-medium">Sobre</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="px-3 py-6 text-center text-fg-subtle">
                      Sin acciones registradas
                    </td>
                  </tr>
                ) : (
                  rows.map((r) => (
                    <tr key={r.id} className="text-fg-muted">
                      <td className="px-3 py-2 whitespace-nowrap">{formatDateTime(r.createdAt)}</td>
                      <td className="px-3 py-2 text-fg">{r.actorUsuario}</td>
                      <td className="px-3 py-2 whitespace-nowrap">{r.action}</td>
                      <td className="px-3 py-2 text-fg-subtle">
                        {r.targetType}
                        {r.targetId ? ` · ${r.targetId}` : ""}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </ListPage>
  );
}
